import { useEffect, useRef, useState } from "react";

import { useMutation } from "@tanstack/react-query";
import { useClickOutside } from "../../Hooks/UseClickOutside";

import { useSelectAQuestion, useSetQuestionId } from "../../Store/QuestionSlice";
import BreakPoints from "../../BreakPoints";
import { Axios } from "../../Axios/createAxios";
export default function QuestionSearch({ position }) {
  const [isFocused, setIsFocused] = useState(false);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const inputRef = useRef(null);
  const { small, xSmall } = BreakPoints();
  useClickOutside(containerRef, () => setIsFocused(false), buttonRef);
  const selectedQuestion = useSelectAQuestion();
  const setQuestionId = useSetQuestionId();
  const fetchData = async (value) => {
    try {
      const res = await Axios.get(`/questions/search?input=${value}`);
      return res;
    } catch (e) {
      throw e;
    }
  };
  const { data, mutate, isIdle, isSuccess, reset, isLoading } = useMutation({
    mutationFn: fetchData,
    onSuccess: (res) => {
      console.log(res);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const handleOnChange = async (e) => {
    const value = parseInt(e.target.value.trim(), 10);
    if (value === "" || !value) {
      reset();
      return;
    }
    mutate(value);
  };

  return (
    <>
      {position !== "header" && (
        <button
          ref={buttonRef}
          className="mixed-c search-toggle"
          onClick={() => {
            setIsFocused((maybeFalseMaybeTrue) => !maybeFalseMaybeTrue);
            inputRef.current.focus();
          }}>
          <i className="fa-solid fa-magnifying-glass" style={{ color: "inherit" }}></i>
        </button>
      )}
      <div className={`search-container ${isFocused === false ? "hide" : ""}`} ref={containerRef}>
        <input
          type="number"
          ref={inputRef}
          name="question_search"
          onChange={handleOnChange}
          onFocus={() => setIsFocused(true)}
          placeholder="Question Id"
        />
        <ul className={`searched-questions  ${isFocused === false ? "hide" : ""}`}>
          <button onClick={() => setIsFocused(false)}>cancel</button>

          {data?.data?.data?.map((item) => {
            const id = item.id;
            const question = item.question;
            const maxLength = 35;
            const displayQuestion = question.length > maxLength ? `${question.slice(0, maxLength)}...` : question;
            return (
              <li
                key={id}
                onClick={() => {
                  setQuestionId(id);
                  selectedQuestion(true);
                }}
                className="pl-5 pr-5">
                <span>Id:{id} </span>
                <p className="text-size-90">{displayQuestion}</p>
              </li>
            );
          })}
          <span className={`${!small && !xSmall ? "absolute center" : "pl-5"}`}>
            {isIdle
              ? "try to find a question."
              : isSuccess && data?.data?.data.length === 0
              ? "We couldn't find a question with that ID."
              : isLoading
              ? "loading ..."
              : ""}
          </span>
        </ul>
      </div>
    </>
  );
}
